import * as React from "react";
import * as R from "ramda";
import { Field } from "react-final-form";
import { connect } from "react-redux";
import { TransaccionSat } from "../modelo/TransaccionSat";

class TiposTransacciones extends React.Component<TiposTransaccionesProps> {

    render() {
        const { className, transaccionesSat } = this.props;
        return (
            <Field name={this.props.name}>
                {({ input, meta }) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {this.renderOpciones(transaccionesSat)}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

    renderOpciones = (transaccionesSat: TransaccionSat[]) => {
        const { gestionables } = this.props;
        return gestionables ?
            transaccionesSat.filter(transaccion => transaccion.esGestionable === gestionables)
                .map(transaccion => <option key={transaccion.codigo} value={transaccion.codigo}>{this.renderNombreTransaccion(transaccion)}</option>)
            : transaccionesSat.map(transaccion => <option key={transaccion.codigo} value={transaccion.codigo}>{this.renderNombreTransaccion(transaccion)}</option>);
    };

    renderNombreTransaccion = (transaccion: TransaccionSat) => {
        const nombre = transaccion.nombre;
        return nombre ? nombre : `SERVICIO CÓDIGO ${transaccion.codigo}`;
    };
}

interface TiposTransaccionesProps {
    name: string,
    transaccionesSat?: Array<TransaccionSat>,
    className?: string,
    gestionables?: boolean,
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store)
    };
})(TiposTransacciones);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TiposTransacciones.tsx